export default "__VITE_ASSET__fed6a432__"